import { graphql } from "./generated/gql";

export const TermsQuery = graphql(`
  query Terms($sponsorId: ID!) {
    terms(sponsorId: $sponsorId) {
      nodes {
        termId
        sponsorId
        interviewType
        title
        durationMinutes
        description
        notionUrl
        summaryDueDate
        createdAt
        updatedAt
      }
      totalCount
    }
  }
`);

export const TermQuery = graphql(`
  query Term($termId: ID!) {
    term(termId: $termId) {
      termId
      sponsorId
      interviewType
      title
      durationMinutes
      description
      notionUrl
      summaryDueDate
      createdAt
      updatedAt
    }
  }
`);

export const CreateTermMutation = graphql(`
  mutation CreateTerm($input: CreateTermInput!) {
    createTerm(input: $input) {
      termId
      sponsorId
      interviewType
      title
      durationMinutes
      description
      notionUrl
      summaryDueDate
      createdAt
      updatedAt
    }
  }
`);

export const UpdateTermMutation = graphql(`
  mutation UpdateTerm($input: UpdateTermInput!) {
    updateTerm(input: $input) {
      termId
      sponsorId
      interviewType
      title
      durationMinutes
      description
      notionUrl
      summaryDueDate
      createdAt
      updatedAt
    }
  }
`);

export const DeleteTermMutation = graphql(`
  mutation DeleteTerm($termId: ID!) {
    deleteTerm(termId: $termId)
  }
`);
